<template>
	<div class="bg-struct bg-struct-details bg-img bg-img-18"></div>
	<div class="main-cont">
		<div id="blog-sec" class="mb-5">&nbsp;</div>
		<section class="blog-sec">
			<div class="card border-0 shadow-sm text-center" v-if="loading">
				<div class="card-body py-4">
					<loading-spinner color="white" text="ЗАГРУЗКА..." />
				</div>
			</div>
			<div class="card border-0 shadow-sm text-center"  v-if="!loading && !blogitem">
				<div class="card-body py-4">
					<h1>ЗАПИСЬ НЕ НАЙДЕНА</h1>
					<div class="mt-4">
						<router-link :to="{path: '/blog', query: Object.assign({}, this.$route.query, {
							category: this.$route.query.category,
							page: this.$route.query.page||1,
						})}" class="btn btn-secondary">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
							<span class="ms-2">Назад</span>
						</router-link>
					</div>
				</div>
			</div>
			<div class="card border-0 shadow-sm" v-if="!loading && blogitem">
				<div class="card-header text-end">
					<div class="d-grid gap-2 d-md-block">
						<router-link :to="{path: '/blog', query: Object.assign({}, this.$route.query, {
							category: this.$route.query.category,
							page: this.$route.query.page||1,
						})}" class="btn btn-secondary">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
							<span class="ms-2">Назад</span>
						</router-link>
						<router-link :to="{path: '/admin/blog/'+$route.params.id, query: Object.assign({}, this.$route.query, {
							category: this.$route.query.category,
							page: this.$route.query.page||1,
						})}" class="btn btn-primary ms-md-2" v-if="authModel.isAdmin()">
							<font-awesome-icon :icon="['fas', 'pen-to-square']" />
							<span class="ms-2">Изменить</span>
						</router-link>
						<button @click="onDelete()" class="btn btn-danger ms-md-2" v-if="authModel.isAdmin()">
							<font-awesome-icon :icon="['fas', 'trash-can']" />
							<span class="ms-2">Удалить</span>
						</button>
					</div>
				</div>
				<img :src="blogitem.poster.url" class="card-img-top" v-if="blogitem.poster" />
				<div class="card-body text-center">
					<div class="text-muted">{{blogitem.category_name}}</div>
					<h4 class="card-title">{{blogitem.title}}</h4>
					<small class="text-body-secondary">{{formatDate(blogitem.dateadd, 'DD.MM.YYYY')}}</small>
				</div>
				<div class="card-body border-1 border-top">
					<div v-highlight v-html="blogitem.content"></div>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
	name: "BlogItem",
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Материал блога | byLex Portfolio'});
	},
	data: () => ({
		blogitem: {},
		
		loading: true,
		error: '',
	}),
	computed: {},
	methods: {
		range: lib.range,
		formatDate: lib.formatDate,
		number_format: lib.number_format,
		
		async loadData(blogitem_id){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doGetBlogItem(blogitem_id);
			if(ret.success){
				this.blogitem = ret.item;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		async onDelete(){
			if(confirm('Вы уверены?')){
				this.loading = true;
				let ret = await this.appModel.doDeleteBlogItem(this.$route.params.id);
				if(ret.success){
					this.$router.push({path: '/blog', query: Object.assign({}, this.$route.query, {
						category: this.$route.query.category,
						page: this.$route.query.page||1,
					})});
				} else {
					alert(ret.message);
				}
				this.loading = false;
			}
		},
		
		getDateDuration(obj){
			return (obj.dateend != '0000-00-00 00:00:00' ?
					(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(obj.dateend, 'YYYY-MM-DD')).days + 1)+
					' '+
					lib.decl1(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(obj.dateend, 'YYYY-MM-DD')).days + 1)
				:
					(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(new Date().toUTCString(), 'YYYY-MM-DD')).days + 1)+
					' '+
					lib.decl1(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(new Date().toUTCString(), 'YYYY-MM-DD')).days + 1)
				);
		},
	},
	async mounted(){
		await this.loadData(this.$route.params.id);
		window.scrollTo(0, 0);
	},
	components: {
		LoadingSpinner,
	},
}
</script>
